module.exports = __webpack_public_path__ + "img/sort_desc.png?51050a68f843a7d6f25d7e1f9a234309";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/icons/sort_desc.png
// module id = 278
// module chunks = 0